import {inject, Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {StorageKeys} from '../utils/constants/storageKeys';

@Injectable({
  providedIn: 'root'
})
export class RecursosService {
  private storage = inject(StorageService);
  public recursos: any;

  constructor() {}

  async cargarRecursos() {
    return fetch('./assets/configs/resources.json')
      .then((response) => response.json())
      .then((resources) => {
        this.storage.set(StorageKeys.RESOURCES, resources);
        this.recursos = resources;
      });
  }
}
